export enum FilterType {
  Hierarchy,
  Checklist,
  List,
  CustomDate,
  DateRange,
  Chips,
  Dropdown,
  Toggle,
}

export enum FilterResponseType {
  Filter,
  Selections,
  GridFilters,
  ReportFilters,
}
